import React from "react";
import { ImSpinner2 } from "react-icons/im";

const Loading = () => {
  return (
    <div className="flex justify-center items-center m-auto">
      <ImSpinner2 color="#0F1E3D" className="text-4xl animate-spin" />
    </div>
  );
};

export default Loading;
